'use strict';

const _=require('pulsar-utils/dist-es6/_');
const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const LoadUrlMatcherTypes=require('../../../../dist-es6/client/services/paramSyncService').LoadUrlMatcherTypes;
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');let

FatigueReportConfig=class FatigueReportConfig{
static get $inject(){return['$stateProvider','$urlMatcherFactoryProvider']}

constructor($stateProvider,$urlMatcherFactoryProvider){
LoadUrlMatcherTypes($urlMatcherFactoryProvider);
let feature=AngularHelpers.generateAuthenticatedFeatureConfig('fatigueReport',{
url:'/fatigueReport?{id:GuidString}&{employeeId:string}&{interval:TimeInterval}&{timezone:Timezone}',
reloadOnSearch:!1,
views:{
"header@":{
templateUrl:null},

"breadcrumbs@":{
templateUrl:`/templates/layout/breadcrumbs`}}});



$stateProvider.state(feature.fullName,feature.config);
}};


module.exports=FatigueReportConfig;
//# sourceMappingURL=fatigueReportConfig.js.map
